export var MARKETING_MESSAGE_LINK_TYPE = /* @__PURE__ */ ((MARKETING_MESSAGE_LINK_TYPE2) => {
  MARKETING_MESSAGE_LINK_TYPE2["FLOW"] = "flow";
  return MARKETING_MESSAGE_LINK_TYPE2;
})(MARKETING_MESSAGE_LINK_TYPE || {});
export var MARKETING_MESSAGE_TYPE = /* @__PURE__ */ ((MARKETING_MESSAGE_TYPE2) => {
  MARKETING_MESSAGE_TYPE2["MESSAGE"] = "message";
  MARKETING_MESSAGE_TYPE2["PURCHASE"] = "purchase";
  MARKETING_MESSAGE_TYPE2["VARIANT_CHOICE"] = "variant_choice";
  return MARKETING_MESSAGE_TYPE2;
})(MARKETING_MESSAGE_TYPE || {});
export const MAX_MARKETING_LIST_CHUNK_SIZE = 1e3;
export var KLAVIYO_RATE_LIMIT_TYPE = /* @__PURE__ */ ((KLAVIYO_RATE_LIMIT_TYPE2) => {
  KLAVIYO_RATE_LIMIT_TYPE2["CREATE_EVENT"] = "klaviyo_create_event";
  KLAVIYO_RATE_LIMIT_TYPE2["CREATE_UPDATE_PROFILE"] = "klaviyo_create_update_profile";
  KLAVIYO_RATE_LIMIT_TYPE2["UPDATE_PROFILE"] = "klaviyo_update_profile";
  KLAVIYO_RATE_LIMIT_TYPE2["GET_LIST_WITH_COUNT"] = "klaviyo_get_list_with_count";
  KLAVIYO_RATE_LIMIT_TYPE2["GET_LIST_WITHOUT_COUNT"] = "klaviyo_get_list_without_count";
  KLAVIYO_RATE_LIMIT_TYPE2["GET_LISTS"] = "klaviyo_get_lists";
  KLAVIYO_RATE_LIMIT_TYPE2["GET_LISTS_OLD"] = "klaviyo_get_lists_old";
  KLAVIYO_RATE_LIMIT_TYPE2["CREATE_LIST"] = "klaviyo_create_list";
  KLAVIYO_RATE_LIMIT_TYPE2["GET_SEGMENT_WITH_COUNT"] = "klaviyo_get_segment_with_count";
  KLAVIYO_RATE_LIMIT_TYPE2["GET_SEGMENT_WITHOUT_COUNT"] = "klaviyo_get_segment_without_count";
  KLAVIYO_RATE_LIMIT_TYPE2["GET_SEGMENTS"] = "klaviyo_get_segments";
  KLAVIYO_RATE_LIMIT_TYPE2["GET_PROFILE"] = "klaviyo_get_profile";
  KLAVIYO_RATE_LIMIT_TYPE2["GET_PROFILES"] = "klaviyo_get_profiles";
  KLAVIYO_RATE_LIMIT_TYPE2["GET_LIST_PROFILES"] = "klaviyo_get_list_profiles";
  KLAVIYO_RATE_LIMIT_TYPE2["GET_SEGMENT_PROFILES"] = "klaviyo_get_segment_profiles";
  KLAVIYO_RATE_LIMIT_TYPE2["ADD_PROFILE_TO_LIST"] = "klaviyo_add_profile_to_list";
  KLAVIYO_RATE_LIMIT_TYPE2["SUBSCRIBE_PROFILES"] = "klaviyo_subscribe_profiles";
  KLAVIYO_RATE_LIMIT_TYPE2["UNSUBSCRIBE_PROFILES"] = "klaviyo_unsubscribe_profiles";
  KLAVIYO_RATE_LIMIT_TYPE2["SPAWN_BULK_IMPORT_PROFILE"] = "klaviyo_spawn_bulk_import_profile";
  KLAVIYO_RATE_LIMIT_TYPE2["GET_BULK_IMPORT_PROFILE_STATUS"] = "klaviyo_get_bulk_import_profile_status";
  return KLAVIYO_RATE_LIMIT_TYPE2;
})(KLAVIYO_RATE_LIMIT_TYPE || {});
export const KLAVIYO_RATE_LIMIT_PER_MINUTE = {
  ["klaviyo_create_event" /* CREATE_EVENT */]: 3500,
  ["klaviyo_create_update_profile" /* CREATE_UPDATE_PROFILE */]: 700,
  ["klaviyo_update_profile" /* UPDATE_PROFILE */]: 700,
  ["klaviyo_get_list_with_count" /* GET_LIST_WITH_COUNT */]: 15,
  ["klaviyo_get_list_without_count" /* GET_LIST_WITHOUT_COUNT */]: 700,
  ["klaviyo_get_lists" /* GET_LISTS */]: 700,
  ["klaviyo_get_lists_old" /* GET_LISTS_OLD */]: 7e3,
  ["klaviyo_create_list" /* CREATE_LIST */]: 150,
  ["klaviyo_get_segment_with_count" /* GET_SEGMENT_WITH_COUNT */]: 15,
  ["klaviyo_get_segment_without_count" /* GET_SEGMENT_WITHOUT_COUNT */]: 700,
  ["klaviyo_get_segments" /* GET_SEGMENTS */]: 700,
  ["klaviyo_get_profile" /* GET_PROFILE */]: 700,
  ["klaviyo_get_profiles" /* GET_PROFILES */]: 700,
  ["klaviyo_get_list_profiles" /* GET_LIST_PROFILES */]: 700,
  ["klaviyo_get_segment_profiles" /* GET_SEGMENT_PROFILES */]: 700,
  ["klaviyo_add_profile_to_list" /* ADD_PROFILE_TO_LIST */]: 150,
  ["klaviyo_subscribe_profiles" /* SUBSCRIBE_PROFILES */]: 700,
  ["klaviyo_unsubscribe_profiles" /* UNSUBSCRIBE_PROFILES */]: 700,
  ["klaviyo_spawn_bulk_import_profile" /* SPAWN_BULK_IMPORT_PROFILE */]: 150,
  ["klaviyo_get_bulk_import_profile_status" /* GET_BULK_IMPORT_PROFILE_STATUS */]: 150
};
